module.exports = __webpack_public_path__ + "static/media/inhaler.e109e17d.svg";